'use client';

import React, { createContext, useId } from 'react';

interface RadioGroupContextValue {
  value?: string | number;
  onChange?: (value: string | number) => void;
  disabled?: boolean;
  name: string;
}

export const RadioGroupContext = createContext<RadioGroupContextValue | null>(null);

interface RadioGroupProps {
  value?: string | number;
  onChange?: (value: string | number) => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
  direction?: 'horizontal' | 'vertical';
}

export default function RadioGroup({
  value,
  onChange,
  disabled,
  className,
  children,
  direction = 'horizontal',
}: RadioGroupProps) {
  const name = useId();

  const classes = [
    'ui-radio-group',
    direction === 'vertical' && 'vertical',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <RadioGroupContext.Provider value={{ value, onChange, disabled, name }}>
      <div className={classes}>{children}</div>
    </RadioGroupContext.Provider>
  );
}
